import GithubBtn from './GithubBtn';

export default GithubBtn;
